import { render, staticRenderFns } from "./Megaphone.vue?vue&type=template&id=38a56084&"
import script from "./Megaphone.vue?vue&type=script&lang=js&"
export * from "./Megaphone.vue?vue&type=script&lang=js&"
import style0 from "./Megaphone.vue?vue&type=style&index=0&id=38a56084&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports